import React, {Component} from 'react';
import ListOfContactsHeader from './components/list-of-contacts-header';
import ListOfContactsBody from "./components/list-of-contacts-body";
import './index.css';

class ListOfContacts extends Component {
    render() {
        return (
            <div className="list-of-contacts">
	            <ListOfContactsHeader/>
                <ListOfContactsBody/>
            </div>
        );
    }
}

export default ListOfContacts;
